import { render, staticRenderFns } from "./FixedBar.vue?vue&type=template&id=e054aa74&"
import script from "./FixedBar.vue?vue&type=script&lang=js&"
export * from "./FixedBar.vue?vue&type=script&lang=js&"
import style0 from "./FixedBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports